// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_q0-0";
export var animationContainer = "_q0-1";
export var itemPrice = "_q0-a";
export var itemizedContent = "_q0-9";
export var itemizedHeader = "_q0-7";
export var itemizedRow = "_q0-8";
export var itemizedSection = "_q0-6";
export var modalContent = "_q0-2";
export var orderName = "_q0-3";
export var refundOption = "_q0-4";
export var refundOptionsContainer = "_q0-5";
export var shippingLabel = "_q0-b";
export var totalRow = "_q0-c";